<template>
  <v-card>
    <v-card-title class=" align-center">
      <v-btn elevation="1" class="mr-3" fab small @click="TOGGLE_CLOSED_BLOCK('parameters')" color="white">
        <v-icon>
          mdi-dots-vertical
        </v-icon>
      </v-btn>
      <h2>Параметры пациента</h2>
      <div class="ml-auto">
        <v-btn depressed color="primary" title="Добавить документ" @click="addDocument">
          <v-icon left>add</v-icon>
          Параметр
        </v-btn>
      </div>
    </v-card-title>

    <parameters-list v-if="isShow" />
  </v-card>
</template>

<script>
import ParametersList from "./components/ParametersList";
import Modal from "@/components/Modal.vue";
import { mapMutations, mapState } from "vuex";
import AddDocument from "@/modules/documents/add-document/AddDocument.vue";

import PatientHeader from "@/components/PatientHeader";
export default {
  components: {
    Modal,
    ParametersList,
    PatientHeader,
  },
  props: {
    hidePatient: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState("ikp", ["closedBlocks"]),
    isShow() {
      return !this.closedBlocks.includes("parameters");
    },
  },
  methods: {
    ...mapMutations("ikp", ["TOGGLE_CLOSED_BLOCK"]),
    addDocument() {
      this.$dialog.showAndWait(AddDocument, { width: "600px", persistent: true, formCategory: 2 });
    },
  },
};
</script>

<style></style>
